<template>
   <div class="container">
      <div class="report">
        <div class="header">
          <span class="line"></span>
          评估报告
        </div>
        <div class="item">
          <div class="item-detail" style="display: inline-block; width:50%">
            <span class="name">评估人：</span>
            <span class="value">{{resultList.entity.GuestName}}</span>
          </div>
            <div class="item-detail" style="display: inline-block; width:40%">
            <span class="name">性别:</span>
            <span class="value">{{resultList.entity.Gender}}</span>
          </div>
            <div class="item-detail">
            <span class="name">身份证号:</span>
            <span class="value">{{resultList.entity.Cerid}}</span>
          </div>
            <div class="item-detail">
            <span class="name">评估体系:</span>
            <span class="value">{{resultList.entity.Name}}</span>
          </div>
            <div class="item-detail">
            <span class="name">评估等级:</span>
            <span class="value">{{resultList.entity.Levelid}}</span>
          </div>
        </div>
      </div>

      <div class="report"  v-if="resultList.entity.Name === '老年人能力评估'">
        <div class="header">
          <span class="line"></span>
          评估报告
        </div>
         <div class="item" style="padding:0">
            <table class="as-card-table" border="1" cellpadding="0" cellspacing="1" >
                <thead>
                  <tr style="background: #FBFCFE">
                      <td colspan="17" >结果判定卡</td>
                  </tr>
                  <tr  style="background: #FBFCFE">
                      <td rowspan="2" colspan="3"  class="w10"  >能力等级</td>
                      <td rowspan="2" colspan="2" >日常生活活动</td>
                      <td colspan="4" >精神状态</td>
                      <td colspan="4" >感知觉与沟通</td>
                      <td colspan="4" >社会参与</td>
                  </tr>
                  <tr style="background: #FBFCFE">
                      <td >0</td>
                      <td >1</td>
                      <td >2</td>
                      <td >3</td>
                      <td >0</td>
                      <td >1</td>
                      <td >2</td>
                      <td >3</td>
                      <td >0</td>
                      <td >1</td>
                      <td >2</td>
                      <td >3</td>
                  </tr>
                </thead>
                <tbody>
                    <tr>
                      <td class="w10" rowspan="4" colspan="3" :class="[cardValue0 === 0?'check-grade':'']">0能力完好</td>
                      <td  v-for="(item , index) in 14" :class="[cardValue0 === 0 && cardValue1 ===0 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2) ?'check-grade':'']" :style="{'background':[2,3,7,11,12].includes(item)?'#B19476': ''}" :key="index">{{item == 1 ? '0' : ''}}</td>
                    </tr>
                    <tr>
                        <td :class="[cardValue0 === 0 && cardValue1 ===1 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-grade':'']"  v-for="(item,index) in 14" :key="index">{{item == 1 ? '1' : ''}}</td>
                    </tr>
                    <tr>
                        <td :class="[cardValue0 === 0 && cardValue1 ===2 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2) ?'check-grade':'']"  v-for="(item,index) in 14" :key="index">{{item == 1 ? '2' : ''}}</td>
                    </tr>
                    <tr>
                        <td :class="[cardValue0 === 0 && cardValue1 ===3 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2) ?'check-grade':'']"  v-for="(item,index) in 14" :key="index">{{item == 1 ? '3' : ''}}</td>
                    </tr>


                    <tr>
                        <td  class="w10" rowspan="4" colspan="3"  :class="[cardValue0 === 1?'check-grade':'']">1轻度失能</td>
                        <td  v-for="(item,index) in 14" :class="[cardValue0 === 1 && cardValue1 === 0 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :style="{'background':[2,4,5,6,8,9,10,13,14].includes(item)?'#9B6A5C': ''}" :key="index">{{item == 1 ? '0' : ''}}</td>
                    </tr>
                    <tr>
                        <td  v-for="(item,index) in 14"  :class="[cardValue0 === 1 && cardValue1 ===1 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']"  :style="{'background':[2,3,4,7,8,10,11,12].includes(item)?'#8097A5': ''}" :key="index">{{item == 1 ? '1' : ''}}</td>
                    </tr>
                    <tr>
                        <td  v-for="(item,index) in 14"  :class="[cardValue0 === 1 && cardValue1 ===2 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :key="index">{{item == 1 ? '2' : ''}}</td>
                    </tr>
                    <tr>
                        <td  v-for="(item,index) in 14"  :class="[cardValue0 === 1 && cardValue1 ===3 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :key="index" >{{item == 1 ? '3' : ''}}</td>
                    </tr>

                    <tr>
                        <td  class="w10" rowspan="4" colspan="3" :class="[cardValue0 === 2?'check-grade':'']">2中度失能</td>
                        <td  v-for="(item,index) in 13" :class="[cardValue0 === 2 && cardValue1 === 0 &&([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :key="index">{{item == 1 ? '0' : ''}}</td>
                    </tr>
                    <tr>
                        <td  v-for="(item,index) in 14" :class="[cardValue0 === 2 && cardValue1 === 1 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :style="{'background':[2,5,6,8,9,10,13,14].includes(item)?'#375289': ''}" :key="index">{{item == 1 ? '1' : ''}}</td>
                    </tr>
                    <tr>
                          <td  v-for="(item,index) in 14"  :class="[cardValue0 === 2 && cardValue1 === 2 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :style="{'background':[2,3,4,5,7,8,9,11,,12,12,13].includes(item)?'#375289': ''}" :key="index">{{item == 1 ? '2' : ''}}</td>
                    </tr>
                    <tr>
                        <td  v-for="(item,index) in 14" :class="[cardValue0 === 2 && cardValue1 === 3 &&([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :key="index">{{item == 1 ? '3' : ''}}</td>
                    </tr>

                    <tr>
                        <td  class="w10" rowspan="4" colspan="3" :class="[cardValue0 === 3?'check-grade':'']">3重度失能</td>
                        <td  v-for="(item,index) in 13" :class="[cardValue0 === 3 && cardValue1 === 0 && ([2+cardValue2,6+cardValue3,10+cardValue4].includes(item) || item === 1)?'check-mark':'']" :key="index">{{item == 1 ? '0' : ''}}</td>
                    </tr>
                    <tr>
                      <td  v-for="(item,index) in 14" :class="[cardValue0 === 3 && cardValue1 === 1 &&([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :key="index">{{item == 1 ? '1' : ''}}</td>
                    </tr>
                    <tr>
                        <td  v-for="(item,index) in 14" :class="[cardValue0 === 3 && cardValue1 === 2 &&([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :style="{'background':[2,5,6,9,10,13,14].includes(item)?'#737373': ''}" :key="index">{{item == 1 ? '2' : ''}}</td>
                    </tr>
                    <tr>
                          <td  v-for="(item,index) in 14" :class="[cardValue0 === 3 && cardValue1 === 3 && ([3+cardValue2,7+cardValue3,11+cardValue4].includes(item) || item === 2)?'check-mark':'']" :style="{'background':![1].includes(item)?'#737373': ''}" :key="index">{{item == 1 ? '3' : ''}}</td>
                    </tr>
                </tbody>
            </table>

            <div class="as-result-hint">
                <ul>
                    <li class="as-result-hint-content">
                        <span class="as-result-waring-img">!</span>
                        <span style="color: black;">注∶使用结果判定卡时，一般根据日常生活活动进行初步定为，锁定目标区域，然后根据其他三项能力，在判定卡上同一颜色区域定为查找相应的能力等级，以下为几种特殊情况:</span>
                    </li >
                      <li  class="as-result-hint-content"><span>(1)</span>当日常生活活动为0，精神状态、感知觉与沟通有一项为1及以上，或社会参与为2，判定为轻度失能; </li>
                      <li  class="as-result-hint-content"><span>(2)</span>当日常生活活动为1，后三项有一项为0或1，判定为轻度失能，后三项均为2或某一项为3，则判定为中度失能; </li>
                      <li  class="as-result-hint-content"><span>(3)</span>当日常生活活动能力为2，后三项全部为2或某一项为3，判定为重度失能，否则为中度失能。 </li>
                </ul>
            </div>
        </div>
      </div>


      <div class="report">
        <div class="header">
          <span class="line"></span>
          评估明细
        </div>
        <div class="item">
          <table  class="as-result-table">
            <tr>
                <th class="as-result-header-detail">题目名称</th>
                <th class="as-result-header-detail">参考值</th>
                <th class="as-result-header-detail">所选项</th>
                <th class="as-result-header-detail">得分</th>
            </tr>
            <tr v-for="(item , index) in resultList.model" :key="index">
                <td class="as-result-cell-b" :style="{background:index % 2 === 0 ?'#81CFE8':''}">{{item.Name}}</td>
                <td class="as-result-cell-b" :style="{background:index % 2 ===0 ?'#81CFE8':''}">{{item.OptionValue}}</td>
                <td class="as-result-cell-b" :style="{background:index % 2 ===0 ?'#81CFE8':''}">{{item.Answer}}</td>
                <td class="as-result-cell-b" :style="{background:index % 2 ===0 ?'#81CFE8':''}">{{item.Value}}</td>
            </tr>
          </table>
        </div>
      </div>

      </div>
</template>

<script>
export default {
  data(){
    return {
      resultList:{
        entity:{},
        list:[],
        model:[],
      }
    }
  },
  created(){
    const id = this.$route.query.id
      this.$axios.post(`/Evaluate/SelectEvalResult?evaId=${id}`).then(res => {
        res.data.obj.entity = res.data.obj.entity[0]
        this.resultList = res.data.obj
        this.resultList.list.forEach(el => {
            if (el.Text.includes('日常生活活动')) this.cardValue1 = el.Level.split(' ')[0] - 0
            if (el.Text.includes('精神状态')) this.cardValue2 = el.Level.split(' ')[0] - 0
            if (el.Text.includes('感知觉与沟通')) this.cardValue3 = el.Level.split(' ')[0] - 0
            if (el.Text.includes('社会参与')) this.cardValue4 = el.Level.split(' ')[0] - 0
        })

        if (this.resultList.entity.Name === '老年人能力评估') {
          switch (this.cardValue1) {
              case 0:
                  if (this.cardValue2 >= 1 || this.cardValue3 >= 1 || this.cardValue4 === 2) this.cardValue0 = 1
                  break;

              case 1:
                  if ([0, 1].includes(this.cardValue2) || [0, 1].includes(this.cardValue3) || [0, 1].includes(this.cardValue4)) {
                      this.cardValue0 = 1
                  } else {
                      this.cardValue0 = 2
                  }
                  break;

              case 2:
                  if ((this.cardValue2 === 3 || this.cardValue3 === 3 || this.cardValue4 === 3) || (this.cardValue2 === 2 && this.cardValue3 === 2 && this.cardValue4 === 2)) {
                      this.cardValue0 = 3
                  } else {
                      this.cardValue0 = 2
                  }
                  break;
              default:
                  this.cardValue0 = 3
                  break;
          }
        }
      })
  },
}
</script>

<style scoped>
.container {
  /* height: 100%; */
  padding: 12px;
  background: #F7F8FA
}

.report {
  width: 100%;
  margin-bottom: 12px;
  border-radius: 8px;
  background: #FFFFFF;
}

.header {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid rgba(2, 159, 209, 0.30);
  font-size: 16px;
  color: #029FD1;
}

.line {
  width: 4px;
  height: 28px;
  margin-right: 4px;
  background: #029FD1;
}

.item {
  padding: 12px;
}

.item-detail {
  padding: 6px 0;
  font-size: 14px;
  color: #333333;
}

.as-card-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  background: #fff;
  color: #0A0E10;
}


.as-card-table thead td {
    color: #7C7E80;
}

.as-card-table tr td {
    position: relative;
        padding: 6px;
    border: 1px solid #EFEFEFFF;
    text-align: center;
    vertical-align: middle;
}

.w10 {
  width: 12px !important;
}


.as-card-table .check-grade {
    background: #FFFE35;
}

.as-card-table .check-mark::before {
    content: "√";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    color: #0089B5;
}
.as-result-waring-img {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-align: center;
  border-radius: 7px;
  margin-right: 2px;
  background: #029FD1;
  color: #fff;
  transform: translate(0,1px);
}


.as-result-hint {
  padding: 4px;
  line-height:1.2;
  margin-top: 6px;
  font-size: 13px;
  color: #7C7E80;
}

.as-result-table {
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
}

.as-result-hint-content {
    display:flex;
    align-items:flex-start;
}

.as-result-header-detail {
  padding: 10px 0;
  background: #E5E5E5;
  font-size: 14px;
  border: 1px solid #EBECED;
}

.as-result-cell-b {
  width: 25%;
  text-align: center;
  padding: 10px 0;
  border: 1px solid #EBECED;
  background: #E5E5E5;
  font-size: 12px;
}




</style>



// WEBPACK FOOTER //
// src/components/assessment/report.vue